<app-header [showToggle]="false" [showSignin]="false"></app-header>
<main id="main" class="main">

  <section class="section dashboard">
    <div class="pagetitle text-center">
      <h1>Meta Description Checker</h1>
      <div class="div-page-description"><h5>Use our free meta description checker tool to check and optimize your meta description to make it SEO friendly.</h5></div>
    </div>
    <div class="container">
      <div class="row">

        <div class="col-lg-11 col-9">
          <form class="form-inline">
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon3">https://</span>

              <input class="form-control" type="search" placeholder="Enter URL without https or http" aria-label="Search" name="url" [(ngModel)]="url" aria-describedby="basic-addon3">
            </div>
          </form>
        </div>
        <div class="col-lg-1 col-3">
          <app-spinner *ngIf="showCheckSeoModalSpinner"></app-spinner>
          <button class="btn btn-primary" type="submit" *ngIf="!showCheckSeoModalSpinner" (click)="checkMetaDescription()">Check</button>
        </div>
      </div>

      <div class="row mt-3" *ngIf="seoResults!=null">

        <div class="col-lg-12">
          <span *ngIf="seoResults.metaDescription!=null">
            <i *ngIf="seoResults.metaDescription!=null && (seoResults.metaDescription.length>149 && seoResults.metaDescription.length<221)" class="bi bi-check-circle-fill text-success"></i>
            <i *ngIf="seoResults.metaDescription!=null && (seoResults.metaDescription.length<150 || seoResults.metaDescription.length>220)" class="bi bi-exclamation-circle-fill text-warning"></i>
            Meta description found.
            <span *ngIf="seoResults.metaDescription.length<150 || seoResults.metaDescription.length>220">Make sure your meta descriptions are well-written and interesting, keeping them between 150 and 220 characters.</span>
          </span>
          
          <span *ngIf="seoResults.metaDescription==null"><i class="bi bi-x-circle-fill text-danger"></i> Meta description not found.</span>

          <div class="alert alert-info show mt-2" role="alert" *ngIf="seoResults.metaDescription!=null">

            <b>Meta Description:</b> {{seoResults.metaDescription}} <br />
            <b>Length:</b> {{seoResults.metaDescription.length}}
          </div>
        </div>
      </div>

      <div class="row mt-3">

        <div class="col-lg-12">

          <div class="accordion accordion-flush" id="faq-group-1">
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" data-bs-target="#faqs-1" type="button" data-bs-toggle="collapse" aria-expanded="false">
                  About Meta Description Checker Tool
                </button>
              </h2>
              <div id="faqs-1" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
                <div class="accordion-body">
                  <p>Unlock the potential of your website's click-through rate and SEO performance with our Meta Description Checker tool. Check if your meta description is long of short and fix it for better SEO.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" data-bs-target="#faqs-2" type="button" data-bs-toggle="collapse" aria-expanded="false">
                  Why Do Meta Descriptions Matter?
                </button>
              </h2>
              <div id="faqs-2" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
                <div class="accordion-body">
                  <p>Meta descriptions play a crucial role in enticing users to click on your website in search results. They provide a concise summary of your page, influencing user engagement and search engine rankings. The Meta Description Checker tool becomes your partner in ensuring that your meta descriptions are not only present but optimized for maximum impact.</p>
                  <p>With attention spans shrinking, a well-crafted meta description can make the difference between a visitor clicking through or scrolling past. Utilize the Meta Description Checker to analyze and enhance your meta descriptions, aligning them with the best practices of SEO.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" data-bs-target="#faqs-3" type="button" data-bs-toggle="collapse" aria-expanded="false">
                  What is the Optimal Length for Meta Descriptions?
                </button>
              </h2>
              <div id="faqs-3" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
                <div class="accordion-body">
                  <p>Discover the Goldilocks zone for your meta descriptions. Too short, and you risk not conveying enough information; too long, and you may lose the user's interest. The Meta Description Checker tool removes the guesswork by providing insights into the optimal length, ensuring that your meta descriptions are concise, impactful, and within the SEO sweet spot.</p>
                  <p>Empowered by active voice suggestions, the tool guides you to craft meta descriptions that resonate with both search engines and your target audience.</p>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" data-bs-target="#faqs-4" type="button" data-bs-toggle="collapse" aria-expanded="false">
                  The Art of Crafting Compelling Meta Content
                </button>
              </h2>
              <div id="faqs-4" class="accordion-collapse collapse" data-bs-parent="#faq-group-1" style="">
                <div class="accordion-body">
                  <p>Crafting compelling meta content is an art. It involves incorporating relevant keywords, summarizing your content effectively, and enticing users to click through. The Meta Description Checker tool simplifies this process by offering real-time analysis and suggestions. Let active voice be your guide as you navigate the intricacies of crafting meta content that maximizes impact.</p>
                  <p>In conclusion, the Meta Description Checker tool is your go-to solution for optimizing meta descriptions and enhancing your website's click-through rate. Elevate your online presence effortlessly with this indispensable tool.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<app-alert [showMessage]="showMessage" [message]="message" [alertType]="alertType">
</app-alert>
<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
